// Source: https://docs.oracle.com/cd/E29584_01/webhelp/mdex_basicDev/src/rbdv_chars_mapping.html

export const isoLatinExtendACharacter = {
    /* eslint-disable */
    'Ā': 'a',
    'ā': 'a',
    'Ă': 'a',
    'ă': 'a',
    'Ą': 'a',
    'ą': 'a',
    'Ć': 'c',
    'ć': 'c',
    'Ĉ': 'c',
    'ĉ': 'c',
    'Ċ': 'c',
    'ċ': 'c',
    'Č': 'c',
    'č': 'c',
    'Ď': 'd',
    'ď': 'd',
    'Đ': 'd',
    'đ': 'd',
    'Ē': 'e',
    'ē': 'e',
    'Ĕ': 'e',
    'ĕ': 'e',
    'Ė': 'e',
    'ė': 'e',
    'Ę': 'e',
    'ę': 'e',
    'Ě': 'e',
    'ě': 'e',
    'Ĝ': 'g',
    'ĝ': 'g',
    'Ğ': 'g',
    'ğ': 'g',
    'Ġ': 'g',
    'ġ': 'g',
    'Ģ': 'g',
    'ģ': 'g',
    'Ĥ': 'h',
    'ĥ': 'h',
    'Ħ': 'h',
    'ħ': 'h',
    'Ĩ': 'i',
    'ĩ': 'i',
    'Ī': 'i',
    'ī': 'i',
    'Ĭ': 'i',
    'ĭ': 'i',
    'Į': 'i',
    'į': 'i',
    'İ': 'i',
    'ı': 'i',
    'Ĳ': 'i',
    'ĳ': 'i',
    'Ĵ': 'j',
    'ĵ': 'j',
    'Ķ': 'k',
    'ķ': 'k',
    'ĸ': 'k',
    'Ĺ': 'l',
    'ĺ': 'l',
    'Ļ': 'l',
    'ļ': 'l',
    'Ľ': 'l',
    'ľ': 'l',
    'Ŀ': 'l',
    'ŀ': 'l',
    'Ł': 'l',
    'ł': 'l',
    'Ń': 'n',
    'ń': 'n',
    'Ņ': 'n',
    'ņ': 'n',
    'Ň': 'n',
    'ň': 'n',
    'ŉ': 'n',
    'Ŋ': 'n',
    'ŋ': 'n',
    'Ō': 'o',
    'ō': 'o',
    'Ŏ': 'o',
    'ŏ': 'o',
    'Ő': 'o',
    'ő': 'o',
    'Œ': 'o',
    'œ': 'o',
    'Ŕ': 'r',
    'ŕ': 'r',
    'Ŗ': 'r',
    'ŗ': 'r',
    'Ř': 'r',
    'ř': 'r',
    'Ś': 's',
    'ś': 's',
    'Ŝ': 's',
    'ŝ': 's',
    'Ş': 's',
    'ş': 's',
    'Š': 's',
    'š': 's',
    'Ţ': 't',
    'ţ': 't',
    'Ť': 't',
    'ť': 't',
    'Ŧ': 't',
    'ŧ': 't',
    'Ũ': 'u',
    'ũ': 'u',
    'Ū': 'u',
    'ū': 'u',
    'Ŭ': 'u',
    'ŭ': 'u',
    'Ů': 'u',
    'ů': 'u',
    'Ű': 'u',
    'ű': 'u',
    'Ų': 'u',
    'ų': 'u',
    'Ŵ': 'w',
    'ŵ': 'w',
    'Ŷ': 'y',
    'ŷ': 'y',
    'Ÿ': 'y',
    'Ź': 'z',
    'ź': 'z',
    'Ż': 'z',
    'ż': 'z',
    'Ž': 'z',
    'ž': 'z',
    'ſ': 's',
    /* eslint-enable */
};
